import { Maybe } from 'graphql/jsutils/Maybe';
import React from 'react';

import { PlaceResult } from '@pflegia/ui/hooks/use-autocomplete-places';

import { InputState } from '../Input.component';

export enum PostalInputVariant {
  Rounded = 'rounded',
  Default = 'default',
}

export enum PostalLocationInputVariant {
  Postal = 'postal',
  Default = 'location',
}

// Minimum properties used by component
type SelectedAddress = { formattedAddress?: string; name?: string; placeId?: Maybe<string> };

export interface PostalInputProps {
  className?: string;
  dropdownHidden?: boolean;
  id?: string;
  inputClassName?: string;
  inputWrapperClassName?: string;
  inputSearchClassName?: string;
  locationVariant?: PostalLocationInputVariant;
  locationsShown?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onDelete?: (address: SelectedAddress, index: number) => void;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onSelected?: (address: PlaceResult) => void | undefined;
  placeholder?: string;
  selectedAddresses?: SelectedAddress[];
  scrollIntoViewOnSuggestions?: boolean;
  /** Show search and add icons when idle; the loading spinner is always shown while searching. */
  showIcon?: boolean;
  /**
   * Input text value.
   */
  value?: string;
  variant?: PostalInputVariant;
  state?: InputState;
  disabled?: boolean;
}
